module.exports = __webpack_public_path__ + "static/media/TopUp.c87a385c.svg";